import $ from "../../../../../src/Resources/core/jsx/utils/jquery-global";
import Widgets from "js-widget-hooks";
import { applyHiddenStatusOfSelector } from "../lib/toggles";

//yeah
$(document).ready(function () {
  $("#mh-timeline-search-field").val("");

  $("#filter").click(function () {
    $(".timeline-section").toggleClass("sidebar");
  });
  $(".timeline-experience-info span").click(function () {
    $(this).parent().toggleClass("active");
  });
  $("#mh-timeline-search-form").on("submit", function (event) {
    event.preventDefault();
    const searchField = $("#mh-timeline-search-field");
    applySearch(searchField);
    applyHiddenStatusOfSelector(".timeline-experience");
  });
  $("#mh-timeline-search-form").on("reset", function () {
    $("div.timeline-experience").each(function () {
      $(this).show();
    });
  });
  $(".sidebar-filter-toggle").click(function () {
    $(".sidebar-filter").toggleClass("show");
  });

  // Scroll to the timeline item referenced by targetId
  // so that "Back to Timeline" returns to the previously viewed entity.
  if (window.location.hash) {
    const targetId = window.location.hash.substring(1);
    const $target = $("#" + targetId);
    if ($target.length) {
      $("html, body").animate({
        scrollTop: $target.offset().top - 100,
      }, 300);
    }
  }
});

function applySearch(searchField) {
  const searchTerm = searchField.val().toLowerCase();
  $("div.timeline-experience").each(function () {
    if (searchTerm === "") {
      $(this).removeClass("timeline-searchbar-hidden");
      return; // Exit the function if searchTerm is empty
    }
    const hiddenTitleElement = $(this).find(".timeline-role");
    const hiddenDescriptionElement = $(this).find(".timeline-description");
    const historyTitleElement = $(this).find(".historical-event-title");
    const normalizedTitle = normalizeText(hiddenTitleElement.text());
    const normalizedDescription = normalizeText(
      hiddenDescriptionElement.text(),
    );
    const historicalEventTitle = normalizeText(historyTitleElement.text());

    if (
      normalizedTitle.includes(searchTerm) ||
      normalizedDescription.includes(searchTerm) ||
      historicalEventTitle.includes(searchTerm)
    ) {
      $(this).removeClass("timeline-searchbar-hidden");
    } else {
      $(this).addClass("timeline-searchbar-hidden");
    }
  });
}
function normalizeText(text) {
  // search should also match "Dusum", "Drogon", "Sonam" etc.
  return text.toLowerCase().trim()
    .normalize("NFD") // decomposes umlauts etc. and adds diacritics
    .replace(/[\u0300-\u036f]/g, ""); // remove diacritical marks
}
